(function($) {
    
    $(document).ready(function() {
        
        $('.wp-block-hoyry-polylang-language-switcher .lang-dropdown-toggle').on('click', function() {
            var $dropdown = $(this).closest('.lang-dropdown');
            var $menu = $dropdown.find('.lang-dropdown-menu');
            $dropdown.toggleClass('is-open');
            $menu.toggleClass('is-open');
        });
        
        $(document).on('click', function(e) {
            if (!$(e.target).closest('.wp-block-hoyry-polylang-language-switcher .lang-dropdown').length) {
                var $dropdown = $('.wp-block-hoyry-polylang-language-switcher .lang-dropdown');
                var $menu = $dropdown.find('.lang-dropdown-menu');
                $dropdown.removeClass('is-open');
                $menu.removeClass('is-open');
            }
        });
        
    });
    
})(jQuery);